const welcomeLetter = ({ price, building, email, date, qrSrc }) => `<!DOCTYPE html>
<html lang="en"><head><meta charset="UTF-8">
<title>Welcome Letter — Affordable Telecom</title>
<link href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600&display=swap" rel="stylesheet">
<style>
@page{size:8.5in 11in;margin:0}*{box-sizing:border-box;margin:0;padding:0}
body{font-family:'DM Sans',sans-serif;background:white}
.page{width:8.5in;min-height:11in;padding:.65in 1in .5in}
.logo{font-size:22px;font-weight:700;color:#1e3a5f;margin-bottom:.45in}
.logo span{color:#22c55e}
.date{font-size:13px;color:#64748b;margin-bottom:20px}
.salutation{font-size:15px;font-weight:600;color:#1e3a5f;margin-bottom:18px}
p{font-size:14px;line-height:1.8;color:#334155;margin-bottom:14px;font-weight:300}
.highlight{background:#f0fdf4;border-left:4px solid #22c55e;padding:14px 18px;border-radius:0 8px 8px 0;margin:20px 0}
ul{margin:0 0 14px 20px}
li{font-size:14px;line-height:1.8;color:#334155;font-weight:300;margin-bottom:3px}
li strong{font-weight:600;color:#1e3a5f}
.sig{margin-top:28px}.sig-name{font-size:15px;font-weight:700;color:#1e3a5f;margin-bottom:2px}
.sig-title{font-size:13px;color:#64748b}
.footer{margin-top:.35in;padding-top:14px;border-top:1px solid #e2e8f0;font-size:11px;color:#94a3b8;text-align:center}
</style></head><body><div class="page">
<div class="logo">Affordable<span>Telecom</span> LLC</div>
<div class="date">${date}</div>
<div class="salutation">Dear Resident,</div>
<p>We are pleased to welcome you to your new home and to introduce you to an exciting amenity that comes with your building — premium internet service, managed by <strong>Affordable Telecom LLC</strong>.</p>
<p>Your building, <strong>${building}</strong>, has partnered with us to bring high-speed Spectrum internet directly to your unit at rates significantly below what you would find on your own. There are no installation fees, no long-term contracts, and no hassle — just fast, reliable internet from the day you move in.</p>
<div class="highlight"><p><strong>What's included in your building's internet program:</strong></p></div>
<ul>
<li><strong>Gig-speed internet</strong> — 1,000 Mbps download speeds, unlimited data</li>
<li><strong>Professional installation</strong> — scheduled at your convenience, at no cost</li>
<li><strong>Equipment included</strong> — modem and router provided at no extra charge</li>
<li><strong>Simple monthly billing</strong> — one payment, easy online account management</li>
<li><strong>24/7 support</strong> — real people available around the clock</li>
</ul>
<p>Getting started takes less than two minutes. Simply scan the QR code on the enclosed sign-up sheet or visit <strong>portal.affordable-telecom.com/get-started</strong>, enter your building address and unit number, and complete your account setup online.</p>
<p>Once your account is verified, we will reach out to schedule installation at a time that works for you. Most installations are completed in under an hour.</p>
<p>If you have any questions at any time, our team is available at <strong>${email}</strong> or through the resident portal. We are committed to making sure your experience is seamless from day one.</p>
<p>We look forward to serving you and welcome you to the Affordable Telecom community.</p>
<div class="sig"><div class="sig-name">The Affordable Telecom Team</div><div class="sig-title">Affordable Telecom LLC · affordable-telecom.com</div></div>
<div class="footer">Affordable Telecom LLC · New York, NY · ${email} · affordable-telecom.com</div>
</div></body></html>`;

const benefitsFlyer = ({ price, building, email, date, qrSrc }) => `<!DOCTYPE html>
<html lang="en"><head><meta charset="UTF-8">
<title>Benefits Flyer — Affordable Telecom</title>
<link href="https://fonts.googleapis.com/css2?family=DM+Serif+Display&family=DM+Sans:wght@300;400;500;600&display=swap" rel="stylesheet">
<style>
@page{size:8.5in 11in;margin:0}*{box-sizing:border-box;margin:0;padding:0}
body{font-family:'DM Sans',sans-serif}
.page{width:8.5in;height:11in;display:grid;grid-template-rows:auto 1fr auto;overflow:hidden}
.header{background:#1e3a5f;padding:36px 56px 30px}
.logo{font-size:20px;font-weight:700;color:white;margin-bottom:20px}.logo span{color:#22c55e}
.headline{font-family:'DM Serif Display',serif;font-size:42px;color:white;line-height:1.1;margin-bottom:10px}
.headline em{font-style:normal;color:#22c55e}
.sub{font-size:14px;color:rgba(255,255,255,.65);font-weight:300;line-height:1.6}
.accent{height:5px;background:linear-gradient(90deg,#22c55e,#2563eb,#1e3a5f)}
.body{padding:32px 56px;display:grid;grid-template-columns:1fr 1fr;gap:24px;align-items:start}
.benefit{display:flex;gap:12px;margin-bottom:16px;align-items:flex-start}
.bi{width:38px;height:38px;border-radius:9px;display:flex;align-items:center;justify-content:center;font-size:17px;flex-shrink:0}
.bi-b{background:#eff6ff}.bi-g{background:#f0fdf4}.bi-p{background:#f5f3ff}.bi-o{background:#fff7ed}.bi-t{background:#f0fdfa}
.bh{font-size:13px;font-weight:700;color:#1e3a5f;margin-bottom:2px}
.bp{font-size:12px;color:#64748b;line-height:1.5;font-weight:300}
.right{display:flex;flex-direction:column;gap:16px}
.price-box{background:#f8fafc;border:1px solid #e2e8f0;border-radius:14px;padding:18px}
.pl{font-size:10px;font-weight:700;letter-spacing:.12em;text-transform:uppercase;color:#94a3b8;margin-bottom:5px}
.pa{font-family:'DM Serif Display',serif;font-size:44px;color:#1e3a5f;line-height:1}
.pp{font-size:13px;color:#64748b}
.pn{font-size:11px;color:#94a3b8;margin-top:5px}
.ps{display:inline-block;background:#dcfce7;color:#16a34a;font-size:11px;font-weight:700;padding:2px 9px;border-radius:20px;margin-top:6px}
.ci{display:flex;align-items:center;gap:9px;margin-bottom:9px;font-size:12px;color:#334155}
.cd{width:17px;height:17px;background:#22c55e;border-radius:50%;display:flex;align-items:center;justify-content:center;flex-shrink:0}
.cd::after{content:'✓';color:white;font-size:9px;font-weight:700}
.qr-box{background:#1e3a5f;border-radius:14px;padding:18px;text-align:center}
.qr-box img{width:100px;height:100px;background:white;border-radius:8px;padding:6px;display:block;margin:0 auto 8px}
.qc{font-size:12px;font-weight:700;color:white;margin-bottom:2px}
.qu{font-size:10px;color:rgba(255,255,255,.45)}
.footer{background:#1e3a5f;padding:14px 56px;display:flex;align-items:center;justify-content:space-between}
.fl{font-size:11px;color:rgba(255,255,255,.5)}.fl strong{color:white;display:block;font-size:12px;margin-bottom:1px}
.fr{font-size:11px;color:rgba(255,255,255,.5);text-align:right}
</style></head><body><div class="page">
<div class="header">
<div class="logo">Affordable<span>Telecom</span> LLC</div>
<div class="headline">Premium internet,<br><em>finally affordable.</em></div>
<div class="sub">${building} includes access to high-speed Spectrum internet at exclusive resident rates — no upfront cost, no long-term commitment.</div>
</div>
<div class="accent"></div>
<div class="body">
<div>
<div style="font-size:15px;font-weight:700;color:#1e3a5f;margin-bottom:16px">What you get</div>
<div class="benefit"><div class="bi bi-b">⚡</div><div><div class="bh">Gig-speed internet</div><div class="bp">1,000 Mbps download. Stream, work, game simultaneously — unlimited data.</div></div></div>
<div class="benefit"><div class="bi bi-g">📶</div><div><div class="bh">Professional-grade WiFi</div><div class="bp">Modem and router included. Professional installation at no cost.</div></div></div>
<div class="benefit"><div class="bi bi-p">💳</div><div><div class="bh">Simple monthly billing</div><div class="bp">One payment, one bill. Set up autopay and never think about it.</div></div></div>
<div class="benefit"><div class="bi bi-o">🎧</div><div><div class="bh">24/7 dedicated support</div><div class="bp">Real people available around the clock — call, chat, or email.</div></div></div>
<div class="benefit"><div class="bi bi-t">✅</div><div><div class="bh">No upfront cost</div><div class="bp">Zero installation fees. No equipment deposits. No annual contracts.</div></div></div>
</div>
<div class="right">
<div class="price-box">
<div class="pl">Your exclusive resident rate</div>
<div><span class="pa">$${price}</span><span class="pp">/month</span></div>
<div class="pn">Internet · Equipment included · No annual contract</div>
<div class="ps">Below retail pricing</div>
</div>
<div>
<div class="ci"><div class="cd"></div>No upfront installation fee</div>
<div class="ci"><div class="cd"></div>Equipment included — no rental fees</div>
<div class="ci"><div class="cd"></div>Autopay available</div>
<div class="ci"><div class="cd"></div>Cancel anytime — no lock-in</div>
<div class="ci"><div class="cd"></div>Online account management</div>
</div>
<div class="qr-box">
<img src="${qrSrc}" alt="Sign up QR code"/>
<div class="qc">Scan to sign up in 2 minutes</div>
<div class="qu">portal.affordable-telecom.com/get-started</div>
</div>
</div>
</div>
<div class="footer">
<div class="fl"><strong>Affordable Telecom LLC</strong>${email} · affordable-telecom.com</div>
<div class="fr">New York, NY<br>Questions? We're here 24/7</div>
</div>
</div></body></html>`;

const howToSignUp = ({ price, building, email, date, qrSrc }) => `<!DOCTYPE html>
<html lang="en"><head><meta charset="UTF-8">
<title>How to Sign Up — Affordable Telecom</title>
<link href="https://fonts.googleapis.com/css2?family=DM+Serif+Display&family=DM+Sans:wght@300;400;500;600&display=swap" rel="stylesheet">
<style>
@page{size:8.5in 11in;margin:0}*{box-sizing:border-box;margin:0;padding:0}
body{font-family:'DM Sans',sans-serif}
.page{width:8.5in;height:11in;display:flex;flex-direction:column}
.header{background:#1e3a5f;padding:28px 56px 24px}
.logo{font-size:18px;font-weight:700;color:white;margin-bottom:14px}.logo span{color:#22c55e}
h1{font-family:'DM Serif Display',serif;font-size:36px;color:white;line-height:1.1}
h1 em{font-style:normal;color:#22c55e}
.hs{font-size:13px;color:rgba(255,255,255,.6);margin-top:6px;font-weight:300}
.accent{height:5px;background:linear-gradient(90deg,#22c55e,#2563eb,#1e3a5f)}
.body{flex:1;padding:32px 56px;display:grid;grid-template-columns:1.1fr 1fr;gap:36px;align-items:start}
.st{font-size:15px;font-weight:700;color:#1e3a5f;margin-bottom:22px}
.step{display:flex;gap:16px;margin-bottom:22px;align-items:flex-start}
.sn{width:40px;height:40px;background:#1e3a5f;color:white;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:17px;font-weight:800;flex-shrink:0;font-family:'DM Serif Display',serif}
.sc h3{font-size:14px;font-weight:700;color:#1e3a5f;margin-bottom:3px}
.sc p{font-size:12px;color:#64748b;line-height:1.6;font-weight:300}
.sc .tip{display:inline-block;background:#f0fdf4;color:#16a34a;font-size:10px;font-weight:600;padding:2px 7px;border-radius:4px;margin-top:5px}
.conn{width:2px;height:14px;background:#e2e8f0;margin-left:19px;margin-bottom:6px}
.qr-col{display:flex;flex-direction:column;gap:16px;padding-top:6px}
.qr-card{background:#1e3a5f;border-radius:16px;padding:22px;text-align:center}
.qe{font-size:10px;font-weight:600;letter-spacing:.14em;color:rgba(255,255,255,.5);text-transform:uppercase;margin-bottom:10px}
.qr-card img{width:150px;height:150px;background:white;border-radius:10px;padding:10px;display:block;margin:0 auto 10px}
.qct{font-size:13px;font-weight:700;color:white;margin-bottom:3px}
.qu{font-size:10px;color:rgba(255,255,255,.45)}
.alt{background:#f8fafc;border:1px solid #e2e8f0;border-radius:12px;padding:16px}
.at{font-size:11px;font-weight:700;color:#1e3a5f;margin-bottom:5px;text-transform:uppercase;letter-spacing:.08em}
.au{font-size:13px;font-weight:700;color:#2563eb;margin-bottom:5px;word-break:break-all}
.an{font-size:11px;color:#64748b;font-weight:300;line-height:1.5}
.nh{background:#fff7ed;border:1px solid #fde68a;border-radius:12px;padding:14px 16px}
.nh h4{font-size:12px;font-weight:700;color:#92400e;margin-bottom:4px}
.nh p{font-size:11px;color:#92400e;line-height:1.5;font-weight:300}
.footer{background:#1e3a5f;padding:12px 56px;display:flex;align-items:center;justify-content:space-between}
.footer span{font-size:11px;color:rgba(255,255,255,.5)}.footer strong{color:white}
</style></head><body><div class="page">
<div class="header">
<div class="logo">Affordable<span>Telecom</span> LLC</div>
<h1>Get connected in<br><em>under 2 minutes.</em></h1>
<div class="hs">Follow these simple steps to activate your internet service at ${building}.</div>
</div>
<div class="accent"></div>
<div class="body">
<div>
<div class="st">How to sign up</div>
<div class="step"><div class="sn">1</div><div class="sc"><h3>Scan the QR code or visit the link</h3><p>Use your phone camera to scan the QR code, or type the address into any browser.</p><span class="tip">Takes less than 10 seconds</span></div></div>
<div class="conn"></div>
<div class="step"><div class="sn">2</div><div class="sc"><h3>Find your building</h3><p>Type in your building address. Select it from the dropdown.</p></div></div>
<div class="conn"></div>
<div class="step"><div class="sn">3</div><div class="sc"><h3>Enter your apartment number</h3><p>Type your unit number exactly as it appears on your lease (e.g. 4B, 12A).</p></div></div>
<div class="conn"></div>
<div class="step"><div class="sn">4</div><div class="sc"><h3>Fill out the short form</h3><p>Enter your name, email, and phone number. Agree to terms and submit.</p><span class="tip">Your information is secure and private</span></div></div>
<div class="conn"></div>
<div class="step"><div class="sn">5</div><div class="sc"><h3>We verify within 24 hours</h3><p>Our team verifies your residency and emails you to set your password and schedule installation.</p></div></div>
</div>
<div class="qr-col">
<div class="qr-card">
<div class="qe">Step 1 — Scan to get started</div>
<img src="${qrSrc}" alt="QR code"/>
<div class="qct">Point your camera here</div>
<div class="qu">portal.affordable-telecom.com/get-started</div>
</div>
<div class="alt">
<div class="at">Or type into your browser</div>
<div class="au">portal.affordable-telecom.com/get-started</div>
<div class="an">Works on any phone, tablet, or computer. No app required.</div>
</div>
<div class="nh">
<h4>Need help signing up?</h4>
<p>Email <strong>${email}</strong> and we'll walk you through it. Available 24/7.</p>
</div>
</div>
</div>
<div class="footer">
<span><strong>Affordable Telecom LLC</strong> · affordable-telecom.com</span>
<span>${email} · Available 24/7</span>
</div>
</div></body></html>`;

const faq = ({ price, building, email, date, qrSrc }) => `<!DOCTYPE html>
<html lang="en"><head><meta charset="UTF-8">
<title>FAQ — Affordable Telecom</title>
<link href="https://fonts.googleapis.com/css2?family=DM+Serif+Display&family=DM+Sans:wght@300;400;500;600&display=swap" rel="stylesheet">
<style>
@page{size:8.5in 11in;margin:0}*{box-sizing:border-box;margin:0;padding:0}
body{font-family:'DM Sans',sans-serif}
.page{width:8.5in;height:11in;display:flex;flex-direction:column}
.header{background:#1e3a5f;padding:24px 56px 20px}
.logo{font-size:18px;font-weight:700;color:white;margin-bottom:10px}.logo span{color:#22c55e}
h1{font-family:'DM Serif Display',serif;font-size:32px;color:white}
.hs{font-size:13px;color:rgba(255,255,255,.6);margin-top:5px;font-weight:300}
.accent{height:5px;background:linear-gradient(90deg,#22c55e,#2563eb,#1e3a5f)}
.body{flex:1;padding:24px 56px;display:grid;grid-template-columns:1fr 1fr;gap:14px 36px;align-content:start}
.faq{break-inside:avoid}
.fq{font-size:12px;font-weight:700;color:#1e3a5f;margin-bottom:4px;display:flex;gap:7px;align-items:flex-start}
.fq::before{content:'Q';display:inline-flex;align-items:center;justify-content:center;width:17px;height:17px;background:#1e3a5f;color:white;border-radius:50%;font-size:9px;font-weight:800;flex-shrink:0;margin-top:1px}
.fa{font-size:11px;color:#475569;line-height:1.6;font-weight:300;padding-left:24px}
.div{height:1px;background:#e2e8f0;margin:10px 0}
.cb{grid-column:1/-1;background:#1e3a5f;border-radius:12px;padding:16px 20px;display:flex;align-items:center;justify-content:space-between;margin-top:4px}
.cb h4{font-size:13px;font-weight:700;color:white;margin-bottom:2px}.cb p{font-size:11px;color:rgba(255,255,255,.6);font-weight:300}
.ce{font-size:13px;font-weight:700;color:#22c55e}
.footer{background:#1e3a5f;padding:11px 56px;display:flex;align-items:center;justify-content:space-between}
.footer span{font-size:11px;color:rgba(255,255,255,.5)}.footer strong{color:white}
</style></head><body><div class="page">
<div class="header">
<div class="logo">Affordable<span>Telecom</span> LLC</div>
<h1>Frequently Asked Questions</h1>
<div class="hs">Everything you need to know about internet service at ${building}.</div>
</div>
<div class="accent"></div>
<div class="body">
<div class="faq"><div class="fq">What is Affordable Telecom LLC?</div><div class="fa">A managed internet services company that partners with residential buildings to provide premium internet at below-retail rates.</div></div><div class="div"></div>
<div class="faq"><div class="fq">Do I have to sign up?</div><div class="fa">Participation is voluntary. However, our building-wide bulk rate means significantly better pricing than signing up on your own.</div></div><div class="div"></div>
<div class="faq"><div class="fq">What internet speeds are included?</div><div class="fa">Gig-speed internet — 1,000 Mbps download with unlimited data. Fast enough to stream 4K, work from home, game, and video call simultaneously.</div></div><div class="div"></div>
<div class="faq"><div class="fq">What does it cost?</div><div class="fa">Your exclusive resident rate is $${price}/month. Includes internet, equipment (modem and router), and professional installation. No upfront fees.</div></div><div class="div"></div>
<div class="faq"><div class="fq">Is there an installation fee?</div><div class="fa">No. Installation is included at no cost. A technician will schedule a time that works for you within a few days of account verification.</div></div><div class="div"></div>
<div class="faq"><div class="fq">Do I need to buy or rent equipment?</div><div class="fa">No. A professional-grade modem and WiFi router are included at no extra charge. No equipment rental fees or deposits.</div></div><div class="div"></div>
<div class="faq"><div class="fq">How do I pay my bill?</div><div class="fa">Through the resident portal at portal.affordable-telecom.com. Set up autopay with a credit card or bank account.</div></div><div class="div"></div>
<div class="faq"><div class="fq">Is there a long-term contract?</div><div class="fa">No annual contract required. Cancel at any time. We earn your business every month by delivering great service.</div></div><div class="div"></div>
<div class="faq"><div class="fq">How long does setup take?</div><div class="fa">Signing up takes under 2 minutes. We verify within 24 hours then schedule installation, typically completed in under an hour.</div></div><div class="div"></div>
<div class="faq"><div class="fq">What if I already have internet?</div><div class="fa">Cancel your existing service and switch. Given our bulk pricing, most residents save money by switching.</div></div><div class="div"></div>
<div class="faq"><div class="fq">What if I have a problem?</div><div class="fa">Our support team is available 24/7. Email ${email} or use the resident portal. We typically respond within a few hours.</div></div><div class="div"></div>
<div class="faq"><div class="fq">What if I move out?</div><div class="fa">Log into your account and cancel. We coordinate equipment retrieval. No early termination fees.</div></div>
<div class="cb"><div><h4>Still have questions?</h4><p>Reach out anytime — we'll get back to you fast.</p></div><div class="ce">${email}</div></div>
</div>
<div class="footer"><span><strong>Affordable Telecom LLC</strong> · affordable-telecom.com</span><span>New York, NY · ${email}</span></div>
</div></body></html>`;

const quickStartCard = ({ price, building, email, date, qrSrc }) => `<!DOCTYPE html>
<html lang="en"><head><meta charset="UTF-8">
<title>Quick Start Card — Affordable Telecom</title>
<link href="https://fonts.googleapis.com/css2?family=DM+Serif+Display&family=DM+Sans:wght@300;400;500;600&display=swap" rel="stylesheet">
<style>
@page{size:8.5in 11in;margin:0}*{box-sizing:border-box;margin:0;padding:0}
body{font-family:'DM Sans',sans-serif;background:white}
.page{width:8.5in;height:11in;display:flex;flex-direction:column}
.card{height:5.4in;display:flex;overflow:hidden;border-bottom:2px dashed #cbd5e1}
.card:last-child{border-bottom:none}
.cl{flex:1;background:#1e3a5f;padding:32px 36px;display:flex;flex-direction:column;justify-content:space-between;position:relative;overflow:hidden}
.cl::before{content:'';position:absolute;bottom:-50px;left:-50px;width:200px;height:200px;background:rgba(34,197,94,.1);border-radius:50%}
.logo{font-size:16px;font-weight:700;color:white;position:relative;z-index:1}.logo span{color:#22c55e}
.ch{font-family:'DM Serif Display',serif;font-size:28px;color:white;line-height:1.15;margin:14px 0;position:relative;z-index:1}
.ch em{font-style:normal;color:#22c55e}
.steps{position:relative;z-index:1}
.sm{display:flex;align-items:flex-start;gap:10px;margin-bottom:10px}
.smn{width:22px;height:22px;background:rgba(255,255,255,.15);border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:11px;font-weight:700;color:white;flex-shrink:0;margin-top:1px}
.smt{font-size:12px;color:rgba(255,255,255,.8);font-weight:300;line-height:1.4}
.cr{width:200px;background:white;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:12px;padding:22px 18px;border-left:1px solid #e2e8f0;flex-shrink:0}
.ql{font-size:9px;font-weight:700;letter-spacing:.1em;text-transform:uppercase;color:#94a3b8;text-align:center}
.qi{width:128px;height:128px;display:block;border-radius:8px}
.pb{background:#f0fdf4;border:1px solid #bbf7d0;border-radius:8px;padding:8px 10px;text-align:center;width:100%}
.pbl{font-size:8px;font-weight:600;letter-spacing:.1em;text-transform:uppercase;color:#94a3b8;margin-bottom:2px}
.pba{font-size:20px;font-weight:800;color:#1e3a5f}
.pbp{font-size:10px;color:#64748b}
.cm{font-size:9px;color:#94a3b8;text-align:center;line-height:1.5}
.cm strong{color:#1e3a5f;display:block;font-size:10px}
.cut{display:flex;align-items:center;gap:8px;padding:2px 20px;background:white}
.cut::before,.cut::after{content:'';flex:1;border-top:1px dashed #cbd5e1}
.ct{font-size:9px;color:#cbd5e1;white-space:nowrap}
</style></head><body><div class="page">
<div class="card">
<div class="cl">
<div class="logo">Affordable<span>Telecom</span> LLC</div>
<div class="ch">Get online in<br><em>under 2 minutes.</em></div>
<div class="steps">
<div class="sm"><div class="smn">1</div><div class="smt">Scan the QR code or visit the website</div></div>
<div class="sm"><div class="smn">2</div><div class="smt">Enter your building address and unit number</div></div>
<div class="sm"><div class="smn">3</div><div class="smt">Fill out the short form and submit</div></div>
<div class="sm"><div class="smn">4</div><div class="smt">We verify and schedule your installation</div></div>
</div>
</div>
<div class="cr">
<div class="ql">Scan to sign up</div>
<img class="qi" src="${qrSrc}" alt="QR code"/>
<div class="pb"><div class="pbl">Resident rate</div><div><span class="pba">$${price}</span><span class="pbp">/mo</span></div></div>
<div class="cm"><strong>Questions?</strong>${email}<br>Available 24/7</div>
</div>
</div>
<div class="cut"><span class="ct">✂ cut here — 2 cards per page</span></div>
<div class="card">
<div class="cl">
<div class="logo">Affordable<span>Telecom</span> LLC</div>
<div class="ch">Get online in<br><em>under 2 minutes.</em></div>
<div class="steps">
<div class="sm"><div class="smn">1</div><div class="smt">Scan the QR code or visit the website</div></div>
<div class="sm"><div class="smn">2</div><div class="smt">Enter your building address and unit number</div></div>
<div class="sm"><div class="smn">3</div><div class="smt">Fill out the short form and submit</div></div>
<div class="sm"><div class="smn">4</div><div class="smt">We verify and schedule your installation</div></div>
</div>
</div>
<div class="cr">
<div class="ql">Scan to sign up</div>
<img class="qi" src="${qrSrc}" alt="QR code"/>
<div class="pb"><div class="pbl">Resident rate</div><div><span class="pba">$${price}</span><span class="pbp">/mo</span></div></div>
<div class="cm"><strong>Questions?</strong>${email}<br>Available 24/7</div>
</div>
</div>
</div></body></html>`;

module.exports = { welcomeLetter, benefitsFlyer, howToSignUp, faq, quickStartCard };
